module.exports = __webpack_public_path__ + "img/LogoBagherawinesBlanc.8f3a0e4f.svg";